import { render, staticRenderFns } from "./ColumnForm.vue?vue&type=template&id=25e4bebb&"
import script from "./ColumnForm.vue?vue&type=script&lang=js&"
export * from "./ColumnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports